var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.99999 1.09282C11.1726 1.09282 13.0115 2.08319 14.1716 2.91414C15.546 3.89859 16.2533 4.85084 16.4367 5.21404C16.2531 5.57721 15.546 6.52945 14.1716 7.51393C13.0115 8.34485 11.1726 9.33522 8.99999 9.33522C6.82734 9.33522 4.98851 8.34485 3.82839 7.51393C2.45369 6.52945 1.74665 5.57721 1.56299 5.21404C1.74665 4.85084 2.45369 3.89859 3.82812 2.91414C4.98851 2.08319 6.82734 1.09282 8.99999 1.09282ZM8.99999 0.0625C4.30569 0.0625 0.5 4.18372 0.5 5.21404C0.5 6.24436 4.30569 10.3655 8.99999 10.3655C13.6943 10.3655 17.5 6.24433 17.5 5.21404C17.5 4.18375 13.6943 0.0625 8.99999 0.0625ZM8.99999 2.12314C7.29303 2.12314 5.90909 3.50708 5.90909 5.21404C5.90909 6.92096 7.29303 8.30493 8.99999 8.30493C10.7069 8.30493 12.0909 6.92096 12.0909 5.21404C12.0909 3.50708 10.7069 2.12314 8.99999 2.12314ZM8.16776 5.21404C7.44552 5.21404 6.86004 4.62855 6.86004 3.90631C6.86004 3.18407 7.44552 2.59861 8.16776 2.59861C8.89001 2.59861 9.47549 3.1841 9.47549 3.90631C9.47549 4.62855 8.89001 5.21404 8.16776 5.21404Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewEye);
export default __webpack_public_path__ + "static/media/previewEye.e13d3850e6c47f62185ef9380f5a236a.svg";
export { ForwardRef as ReactComponent };